export default __webpack_public_path__ + "static/media/csvIcon_black.e74d0ab2.svg";